:host {
	max-width: min(100%, 56rem);
	margin-inline: auto;
	display: grid;
	grid-template-columns: 12rem 1fr;
	gap: 1rem;
}
:host > div {
	grid-column: 1 / -1;
}


/* Mobile */
@media (max-width: 48rem) {
	:host {
		grid-template-columns: 1fr;
	}
}
